/* Sticky Add to cart (snippets/sticky-atc.liquid). */
(() => {
  if (customElements.get('sticky-atc')) return;
  customElements.define('sticky-atc', class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.main = this.form && this.form.querySelector('[name="add"]');
      if (!this.main) return;
      this.hidden = false;
      this.button = this.querySelector('[data-satc-button]');
      this.label = this.querySelector('[data-satc-label]');
      this.meta = this.querySelector('[data-satc-meta]');
      this.mainVisible = true;
      this.pastForm = false;
      new IntersectionObserver(([e]) => {
        this.mainVisible = e.isIntersecting;
        // Only show once the shopper has scrolled past the button, not before reaching it.
        this.pastForm = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.update();
      }).observe(this.main);
      this.button.addEventListener('click', () => {
        if (this.main.disabled) return;
        this.main.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.main.click();
      });
      // The main button's text (incl. the frame total) and state change with variant / frame.
      new MutationObserver(() => this.sync()).observe(this.main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('change', () => setTimeout(() => this.sync(), 0));
      // Step aside while the cart drawer or a dialog (add-a-frame popup, size guide) is open.
      new MutationObserver(() => this.update()).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('toggle', () => this.update(), true);
      document.addEventListener('close', () => setTimeout(() => this.update(), 0), true);
      document.addEventListener('click', () => setTimeout(() => this.update(), 50));
      this.sync();
    }

    sync() {
      const main = this.main.querySelector(':scope > span');
      const total = this.main.querySelector('.fs-atc-total');
      const text = (main ? main.textContent : this.main.textContent).replace(/\s+/g, ' ').trim();
      this.label.textContent = total ? `${text} ${total.textContent.trim()}` : text;
      this.button.disabled = this.main.disabled;
      const parts = [];
      const select = document.querySelector('variant-selects select, variant-radios input:checked');
      if (select && select.value) parts.push(select.value);
      const frame = document.querySelector('[data-fs-current]');
      if (frame && frame.textContent.trim()) parts.push(frame.textContent.trim());
      this.meta.textContent = parts.join(' · ');
    }

    update() {
      const blocked = document.body.classList.contains('js-cart-drawer-open') || document.querySelector('dialog[open]');
      this.classList.toggle('is-visible', this.pastForm && !this.mainVisible && !blocked);
    }
  });
})();
